document.addEventListener("DOMContentLoaded", async function () {
    const SECTION_ID = "api-cart";
    const giftIds = (window.gift_ids || "").split(",");

    if (!giftIds.length) return;

    const freeInputs = () => document.querySelectorAll("input[data-id-gift]");
    if (!freeInputs().length) return;

    const events = [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.variantChange];

    await updateGiftRules();

    events.forEach(event => subscribe(event, async () => await updateGiftRules()));

    async function updateGiftRules() {
        try {
            const cartItems = await getCartItems();
            freeInputs().forEach(input => input.removeAttribute("disabled"));

            cartItems.forEach(item => {
                const isGift = giftIds.some(id => Number(id) === Number(item.product_id));
                if (!isGift) return;

                document
                    .querySelectorAll(`input[data-id-gift="${item.variant_id}"]`)
                    .forEach(input => input.setAttribute("disabled", "true"));
            });

        } catch (error) {
            console.log(error)
        }
    }

    async function getCartItems() {
        try {
            const response = await fetch(`${window.Shopify.routes.root}?section_id=${SECTION_ID}`);
            const html = new DOMParser().parseFromString(await response.text(), "text/html");
            const script = html.querySelector("[data-cart-api]");
            return parseCartScript(script)?.items ?? [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    function parseCartScript(script) {
        if (!script?.textContent) return null;
        try {
            return JSON.parse(script.textContent);
        } catch (error) {
            console.error(error);
            return null;
        }
    }
});
